module.exports = __webpack_public_path__ + "img/paul_h_2.7668cc56.png";